import "./index.less";
import React from "react";

import ProxyImage from "@/components/ProxyImage";
import ServicesContactLine from "@/components/ServicesContactLine";
import useLogoutEffect from "@/hooks/useLogoutEffect";
import PhoneOrWeChatLogin from "@/components/PhoneOrWeChatLogin";
import { independentManualLoginUrl } from "@/services/getWechatLoginUrl";
import { registerBackgroundUrl } from "@/config";

interface IndependentManualLogin {}

const IndependentManualLogin: React.FC<IndependentManualLogin> = function (props) {
    useLogoutEffect();

    return (
        <div className="ec-independent-manual-register-page">
            <div className="background-image">
                <ProxyImage src={registerBackgroundUrl} alt="" />
            </div>

            <div className="main-container">
                <div className="title">
                    <img
                        src="https://img.alicdn.com/imgextra/i3/54458674/O1CN01WmKWyp2DwkBLqbjgu_!!54458674.png"
                        alt=""
                        className="w50 h50"
                    />
                    <span className="ml10">发货易-自由打印版</span>
                </div>

                <div className="tip">适用微商/快递员/线下商家</div>

                <PhoneOrWeChatLogin
                    redirectUrlPath="/"
                    weChatIframeSrc={independentManualLoginUrl}
                    registerUrl="/register/independentManual"
                />

                <div className="mt20">
                    <ServicesContactLine />
                </div>
            </div>

            <div className="footer"></div>
        </div>
    );
};

export default IndependentManualLogin;
